import React, {Dispatch, SetStateAction} from "react"
import {Route, Routes} from "react-router-dom"
import {RepoDB} from "../../models/RepoDB.model"
import {Code} from "../../pages/Repo/Code"
import {Issues} from "../../pages/Repo/Issues"
import {IssueDetails} from "../../pages/Repo/Issues/IssueDetails"
import {PullRequestPage} from "../../pages/Repo/PR"
import {Settings} from "../../pages/Repo/Settings"
import {AllBranches} from "../../pages/Repo/AllBranches"
import { CommitHistory } from "../../pages/Repo/CommitHistory"

export const RepoContentRoutes = (props: {
  cloneCnt: number,
  repoDB?: RepoDB,
  repoReplCnt: number,
  setRepoReplCnt: Dispatch<SetStateAction<number>>,
}) => {
  return (
    <Routes>
      <Route path="/codes/*"
             element={<Code cloneCnt={props.cloneCnt}/>}/>
      <Route path="/prs/*" element={<PullRequestPage repoDB={props.repoDB}
                                                     repoReplCnt={props.repoReplCnt}
                                                     setRepoReplCnt={props.setRepoReplCnt}
      />}/>
      <Route path="/issues" element={<Issues/>}/>
      <Route path="/issues/:issueId" element={<IssueDetails/>}/>
      <Route path="/settings" element={<Settings repoDB={props.repoDB}/>}/>
      <Route path="/branches" element={<AllBranches />} />
      <Route path="/commits/:branch" element={<CommitHistory />} />
    </Routes>
  )
}
